import { useRef } from "react";
import { useSite } from "@/context/SiteContent";
import { Tilt } from "./Tilt";

const SPARKS = [
  { top: "14%", left: "9%", size: 16, delay: 0 },
  { top: "72%", left: "5%", size: 11, delay: 1.3 },
  { top: "24%", left: "94%", size: 18, delay: 0.6 },
  { top: "80%", left: "90%", size: 13, delay: 2.0 },
  { top: "52%", left: "48%", size: 10, delay: 2.6 },
];
const DOTS = Array.from({ length: 20 });

export const BrandStory = () => {
  const { brandStory } = useSite();
  const secRef = useRef(null);
  const raf = useRef(null);
  if (!brandStory) return null;
  const { eyebrow, heading, lead, items = [], promiseLabel, promise, themeLabel, theme } = brandStory;

  const onMove = (e) => {
    const el = secRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;
    if (raf.current) cancelAnimationFrame(raf.current);
    raf.current = requestAnimationFrame(() => {
      el.style.setProperty("--spot-x", `${x}%`);
      el.style.setProperty("--spot-y", `${y}%`);
    });
  };

  return (
    <section ref={secRef} className="brand-story-section" id="brand-story" data-testid="brand-story-section" onMouseMove={onMove}>
      <div className="brand-story-spot" aria-hidden="true" />
      <div className="brand-story-particles" aria-hidden="true">
        {DOTS.map((_, i) => (
          <span key={i} className="bs-dot" style={{ left: `${(i * 5.1 + 3) % 97}%`, top: `${(i * 41) % 96}%`, animationDelay: `${(i % 7) * 0.6}s`, animationDuration: `${6 + (i % 5)}s` }} />
        ))}
        {SPARKS.map((s, i) => (
          <span key={`s${i}`} className="bs-spark" style={{ top: s.top, left: s.left, width: s.size, height: s.size, animationDelay: `${s.delay}s` }} />
        ))}
      </div>

      <div className="container brand-story-inner">
        <div className="brand-story-head reveal">
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          <h2>{heading}</h2>
          {lead && <p className="lead">{lead}</p>}
        </div>
        <div className="brand-story-grid">
          {items.map((it, i) => (
            <Tilt key={i} max={9} className="brand-story-card reveal" data-testid={`brand-story-card-${i}`} style={{ transitionDelay: `${i * 90}ms` }}>
              <span className="bs-card-index">{String(i + 1).padStart(2, "0")}</span>
              <span className="brand-story-term">{it.term}</span>
              {it.meaning && <span className="brand-story-meaning">{it.meaning}</span>}
              <p>{it.text}</p>
              <span className="bs-card-line" aria-hidden="true" />
            </Tilt>
          ))}
        </div>
        {(promise || theme) && (
          <div className="brand-story-band reveal" data-testid="brand-story-band">
            {promise && <div className="brand-story-line"><span>{promiseLabel}</span><strong>{promise}</strong></div>}
            {theme && <div className="brand-story-line"><span>{themeLabel}</span><strong>{theme}</strong></div>}
          </div>
        )}
      </div>
    </section>
  );
};
